import { EVENTS } from '@/lib/consts.js'

export const WORKSPACE = 'ad36a809f892895bc5fb0836c95f482d'

export const EXCLUDED_ANALYTIC_EVENTS = [
  EVENTS.INIT,
  EVENTS.PAGE_VIEW,
] as const
